export default __webpack_public_path__ + "static/media/device-off.0a4b23d3.svg";